var _circle, _polyline, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowLeftCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-arrow-left-circle",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "12 8 8 12 12 16"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 12,
  x2: 8,
  y2: 12
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left-circle.d14a0484.svg";
export { ForwardRef as ReactComponent };